import Swiper, { Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';

export const avisSlider = () => {
    const container = document.querySelector('[js-avis-slider]');

    if (container) {
        const swiper = new Swiper(container, {
            modules: [ Pagination ],
            init: false,
            speed: 500,
            effect: 'slide',
            slidesPerView: 1,
            spaceBetween: 16,
            grabCursor: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 1.2,
                    spaceBetween: 24
                },
                1280: {
                    slidesPerView: 1.6
                },
            },
        });

        swiper.init();
    }
};
